import React from "react";
import { Chip } from "@mui/material";
import { format, parse } from "date-fns";

const formatTimeRange = (startTime, endTime) => {
  const start = parse(String(startTime || "00:00"), "HH:mm", new Date());
  const end = parse(String(endTime || "00:00"), "HH:mm", new Date());
  return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`;
};

const BatchChip = ({ batch, onClick }) => {
  const label = `${batch.label} (${formatTimeRange(
    batch.startTime ?? batch.time,
    batch.endTime ?? batch.time
  )})`;
  return (
    <Chip
      label={label}
      size="small"
      onClick={() => onClick(batch)}
      sx={{
        bgcolor: batch.color.bg,
        color: batch.color.text,
        fontWeight: 500,
        fontSize: 10,
        height: 20,
        borderRadius: "4px",
        mb: "2px",
        "& .MuiChip-label": { px: "6px" },
        cursor: "pointer",
      }}
    />
  );
};

export default BatchChip;

